import React from 'react';
import { BLOCK_EXPLORER_BLOCK_ID_URL, BLOCK_EXPLORER_TXN_ID_URL } from '../../../utils/config';
import { formatUTCDate } from '../../../utils/converter';

const BlockchainDetailsTS = ({ reportData, blockHistory }) => {
  // If there's no REQ_ID, render a single block from reportData
  let blockList = reportData.REQ_ID ? blockHistory : [reportData];

  return (
    <div className="flex flex-col rounded-lg bg-[#17191C] p-4 sm:p-6 gap-4 sm:gap-6">
      <h3 className="font-normal text-xl sm:text-2xl md:text-2xl space-y-4 sm:space-y-6">
        Blockchain Details
      </h3>

      <table className="w-full table-fixed file-table">
        <tbody className="w-full flex flex-col ">
          {blockList.map((block: BlockchainData, index: number) => (
            <React.Fragment key={index}>
              <tr className="flex flex-row bg-c-black-c-2023 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-t-sm mb-1">
                <th className="w-[20%] text-white text-sm sm:text-base">Block:</th>
                <td className="w-[80%] font-normal text-core-grey-80 text-sm sm:text-base">
                  <a
                    href={`${BLOCK_EXPLORER_BLOCK_ID_URL}/${block.TXPOW_ID}`}
                    target="_blank"
                    className="text-orange cursor-pointer break-all hover:underline"
                  >
                    {block.BLOCK}
                  </a>
                </td>
              </tr>
              <tr className="flex flex-row bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 mb-1">
                <th className="w-[20%] text-white text-sm sm:text-base">Txn ID:</th>
                <td className="w-[80%] font-normal text-core-grey-80 text-sm sm:text-base">
                  <a
                    href={`${BLOCK_EXPLORER_TXN_ID_URL}/${block.TRANSACTION_ID}`}
                    target="_blank"
                    className="text-orange cursor-pointer break-all hover:underline"
                  >
                    {block.TRANSACTION_ID}
                  </a>
                </td>
              </tr>
              <tr className="flex flex-row bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 mb-1">
                <th className="w-[20%] text-white text-sm sm:text-base">Date:</th>
                <td className="w-[80%] font-normal text-core-grey-80 text-sm sm:text-base">
                  {block.BLOCK_DATE && formatUTCDate(block.BLOCK_DATE)} UTC
                </td>
              </tr>
              <tr className="flex flex-row bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-b-sm mb-4">
                <th className="w-[20%] text-white text-sm sm:text-base">Coin ID:</th>
                <td className="w-[80%] font-normal text-core-grey-80 text-sm sm:text-base break-all">
                  {block?.COIN_ID || '-'}
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlockchainDetailsTS;
